import ClockoutController from '../../../core/clockout.controller';
import Inherit from '../../../core/inherit';
import NewSidebarDelegate from './newSidebar.delegate';

class NewSidebarController extends Inherit(ClockoutController, NewSidebarDelegate) {
    collapseTimer = null;

    async initialize() {
        // Set active item based on current route
        const location = window.location.pathname;
        this.setActiveItemFromRoute(location);
        this.startTimer();
    }

    async cleanup() {
        // Cleanup collapse timer on unmount
        if (this.collapseTimer) {
            clearTimeout(this.collapseTimer);
            this.collapseTimer = null;
        }
    }

    startTimer() {
        this.collapseTimer = setTimeout(() => {
            this.setCollapsed(true);
            this.collapseTimer = null;
        }, 5000);
    }

    handleMouseEnter = () => {
        // Cancel any pending collapse timer
        if (this.collapseTimer) {
            clearTimeout(this.collapseTimer);
            this.collapseTimer = null;
        }
        
        // Expand the sidebar
        this.setCollapsed(false);
    };

    handleMouseLeave = () => {
        // Start a 3-second timer to collapse the sidebar
        if (this.collapseTimer) {
            clearTimeout(this.collapseTimer);
        }
        
        this.startTimer();
    };

    setActiveItemFromRoute = (pathname) => {
        const routeMap = {
            '/dashboard': 'home',
            '/treasury': 'cashflow',
            '/configurations': 'configurations',
            '/billing': 'billing',
            '/team': 'team',
            '/reports': 'reports',
            '/ledger': 'reports',
            '/reconciliation': 'reports'
        };

        const activeItem = routeMap[pathname] || 'home';
        this.setActiveItem(activeItem);
    };

    handleItemClick = (itemKey) => {
        this.setActiveItem(itemKey);
        
        // Cancel any pending collapse timer when clicking a menu item
        if (this.collapseTimer) {
            clearTimeout(this.collapseTimer);
            this.collapseTimer = null;
        }
        
        // Keep the menu expanded
        this.setCollapsed(false);
        
        // Navigate to appropriate route using props.navigate
        const routeMap = {
            'home': '/dashboard',
            'cashflow': '/treasury',
            'configurations': '/configurations',
            'billing': '/billing',
            'team': '/team',
            'reports': '/reports'
        };

        const route = routeMap[itemKey];
        if (route && this.props.navigate) {
            this.props.navigate(route);
        }
    };
}

export default NewSidebarController;
